import { assignModel } from '@/common/helpers/assignModel';

export type ContactId = number;

export class ContactModel {
  id!: ContactId;
  firstName!: string;
  lastName!: string;
  email!: string;
  description!: string;
}

// "assignee" and "contact" (sometimes ContactLike) are now synonyms in the codebase.
// Historically, "assignee" referred to a union type (Contact | AccessGroup),
// but that concept has since been removed.
export class Contact extends ContactModel {
  constructor(model: ContactModel) {
    super();

    assignModel<ContactModel>(this, model);
  }

  get name() {
    if (this.firstName && this.lastName) {
      return `${this.firstName} ${this.lastName} / ${this.email}`;
    }

    return this.email;
  }

  get shortName() {
    return this.email;
  }

  // It was unclear during AccessEntry deletion whether this function is still needed.
  // It remains necessary if EmailOnlyContact and Contact can coexist in the same array.
  // This case is not fully verified, so the function is kept to avoid potential regressions.
  getUniqueId() {
    return `${this.email}-contact`;
  }
}
